module.exports = __webpack_public_path__ + "img/armaBoca8.e2602cc2.jpg";